import React from "react";
import { cn } from "@semo/shared-ui";

interface TypingIndicatorProps {
  className?: string;
  partyName?: string; // e.g. "구매자", "공급사"
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  className,
  partyName,
}) => {
  return (
    <div className={cn("flex items-center gap-2 px-4 py-2", className)}>
      <div className="flex space-x-1">
        <div className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-bounce"></div>
      </div>
      {partyName && (
        <span className="text-xs text-slate-400 animate-pulse">
          {partyName}가 입력 중입니다...
        </span>
      )}
    </div>
  );
};
